import type { StorageProviderName } from "../../domain/storage";

export const DEV_STORAGE_PROVIDER_ENV_KEY = "VITE_DEV_STORAGE_PROVIDER";

const ALLOWED_STORAGE_PROVIDERS: ReadonlyArray<StorageProviderName> = [
  "local",
  "server",
  "cloud",
];

interface ResolveStorageProviderOptions {
  isDevelopment: boolean;
  envValue: string | null | undefined;
  defaultProvider?: StorageProviderName;
}

function normalizeProviderValue(value: string | null | undefined): string {
  return String(value ?? "")
    .trim()
    .toLocaleLowerCase("en-US");
}

function isStorageProviderName(value: string): value is StorageProviderName {
  return ALLOWED_STORAGE_PROVIDERS.includes(value as StorageProviderName);
}

export function resolveStorageProviderFromEnv(
  options: ResolveStorageProviderOptions,
): StorageProviderName {
  const defaultProvider = options.defaultProvider ?? "local";
  if (!options.isDevelopment) {
    return defaultProvider;
  }

  const normalized = normalizeProviderValue(options.envValue);
  if (!normalized) {
    return defaultProvider;
  }

  if (isStorageProviderName(normalized)) {
    return normalized;
  }

  return defaultProvider;
}

function readDevStorageProviderFromImportMetaEnv(): string {
  const env = import.meta.env as unknown as Record<string, unknown>;
  return String(env[DEV_STORAGE_PROVIDER_ENV_KEY] ?? "");
}

export function resolveRuntimeStorageProvider(): StorageProviderName {
  return resolveStorageProviderFromEnv({
    isDevelopment: Boolean(import.meta.env.DEV),
    envValue: readDevStorageProviderFromImportMetaEnv(),
    defaultProvider: "local",
  });
}
